import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Download, Search, Play } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    icon: <Download className="w-8 h-8 text-accent" data-id="element-98" />,
    title: 'Descarga',
    desc: 'Recibes el acceso inmediato a tu correo tras el pago.'
  }, {
    num: '2',
    icon: <Search className="w-8 h-8 text-accent" data-id="element-99" />,
    title: 'Identifica',
    desc: 'Usas nuestra guía de 10 segundos para confirmar que es un cólico.'
  }, {
    num: '3',
    icon: <Play className="w-8 h-8 text-accent" data-id="element-100" />,
    title: 'Aplica',
    desc: 'Ejecutas la secuencia de 15 minutos y recuperas el silencio.'
  }];
  return <section className="py-24 bg-cream-dark" data-id="element-101">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-102">
        <FadeIn data-id="element-103">
          <div className="text-center mb-20" data-id="element-104">
            <h2 className="text-3xl md:text-4xl font-bold text-earth-darker mb-4" data-id="element-105">
              CÓMO FUNCIONA:
            </h2>
            <div className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-106" />
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-12 relative" data-id="element-107">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16.66%] right-[16.66%] h-0.5 bg-earth-light/50 -z-10" data-id="element-108" />

          {steps.map((step, idx) => <FadeIn key={idx} delay={idx * 0.15} className="relative text-center" data-id="element-109">
              <div className="w-24 h-24 mx-auto bg-white rounded-full flex items-center justify-center shadow-sm border-4 border-cream-dark mb-8 relative z-10 group hover:scale-105 transition-transform" data-id="element-110">
                {step.icon}
                <div className="absolute -top-3 -right-3 w-8 h-8 bg-earth-darker text-white rounded-full flex items-center justify-center font-bold text-sm shadow-md" data-id="element-111">
                  {step.num}
                </div>
              </div>
              <h3 className="text-2xl font-bold text-earth-darker mb-4" data-id="element-112">
                {step.title}
              </h3>
              <p className="text-lg text-earth-dark leading-relaxed" data-id="element-113">
                {step.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}